import { combineReducers } from 'redux';

import { language } from './reducers/language';

export default combineReducers({
  language,
});
